import { IconButton, InputAdornment, Tooltip as MaterialTooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";

type TooltipProps = {
    text: string;
    className?: string;
    iconSize?: "small" | "medium" | "large";
};

export function Tooltip({ text, className, iconSize = "small" }: TooltipProps) {
    return (
      <InputAdornment position="end" className={className}>
          <MaterialTooltip
            slotProps={{
                tooltip: {
                    sx: {
                        fontSize: '16px',
                        minWidth: '280px',
                    },
                },
            }}
            placement="top"
            title={<span style={{ whiteSpace: 'pre-line' }}>{text}</span>}
            enterTouchDelay={0}
            leaveTouchDelay={3000}
            arrow
          >
              <IconButton
                sx={{
                  padding: 0,
                  minWidth: 'auto',
                  width: 'auto',
                  height: 'auto',
                  cursor: 'initial',
              }}>
                  <InfoOutlinedIcon sx={{ color: '#0288d1' }} fontSize={iconSize} />
              </IconButton>
          </MaterialTooltip>
      </InputAdornment>
    )
}
